import React from 'react'

import get from 'lodash/get'
import defaultTo from 'lodash/defaultTo'

import { IEditableTableHead } from './head'
import { IItem } from './rapidEditableTableData'
import { IEditableItem } from 'components/layout/editableTable'

import RapidEditableTableData from './rapidEditableTableData'
import TableData from 'components/layout/table/tableData'

interface IProps {
  item: IEditableItem
  head: IEditableTableHead[]
  onChange?: (item: IEditableItem) => void
}

const RapidEditableTableRow: React.FC<IProps> = props => {
  const { head, item, onChange } = props

  const handleInputChange = (key: string, data: IItem) => {
    if (onChange) {
      onChange({
        ...item,
        data: {
          ...item.data,
          [key]: {
            ...getItem(key),
            ...data,
          },
        },
      })
    }
  }

  const getItem = (key: string) => {
    if (item.data && item.data[key]) {
      return item.data[key]
    } else {
      return {
        value: '',
        unit: '',
      }
    }
  }

  const getValue = (key: string) => {
    if (item.data && item.data[key]) {
      const { value } = item.data[key]
      return value
    }

    return undefined
  }

  const getUnit = (headItem: IEditableTableHead) => {
    const { key } = headItem

    if (getValue(key) === '*') {
      return undefined
    }

    return get(item, `data[${key}]unit`, headItem.unit)
  }

  return (
    <div className="flex">
      <div className={`w-full flex flex-col`}>
        <div className={`flex items-end`}>
          {head.map((headItem: IEditableTableHead) => {
            const item = getItem(headItem.key)
            if (item.editable || headItem.editable) {
              return (
                <RapidEditableTableData
                  key={headItem.key}
                  name={headItem.key}
                  col={headItem.col}
                  item={getItem(headItem.key)}
                  onChange={(key, value) => handleInputChange(key, value)}
                  placeholder={headItem.placeholder}
                  unit={getUnit(headItem)}
                  leftAlign={headItem.leftAlign}
                />
              )
            } else {
              return (
                <TableData
                  key={headItem.key}
                  name={headItem.key}
                  col={headItem.col}
                  text={getValue(headItem.key)}
                  unit={getUnit(headItem)}
                  hideUnit={defaultTo(headItem.hideUnit, false)}
                />
              )
            }
          })}
        </div>
      </div>
    </div>
  )
}

export default RapidEditableTableRow
